import {LanguageProvider} from "../context/LanguageContext";
import {ConfigProvider} from "../context/ConfigContext";
import {ModalProvider} from "../context/ModalContext";
import {TextSectionsListProvider} from "../context/TextSectionsListContext";
import {AuthProvider} from "../context/LoginContext";
import {SavedConfigurationsProvider} from "../context/SavedConfigurationsContext";
import {EditTypeProvider} from "../context/EditTypeContext";
import {LoaderProvider} from "../context/LoaderContext";
import {PriceProvider} from "../context/PriceContext";
import {WorkingSizeProvider} from "../context/WorkingSizeContext";
import {LettersProvider} from "../context/LettersContext";
import {PriceCalculationProvider} from "../context/PriceCalculationContext";

export const Providers = ({children}) => {
    return (
        <LanguageProvider>
            <ConfigProvider>
                <WorkingSizeProvider>
                    <PriceProvider>
                        <TextSectionsListProvider>
                            <PriceCalculationProvider>
                            <LettersProvider>
                                <ModalProvider>
                                    <AuthProvider>
                                        <SavedConfigurationsProvider>
                                            <EditTypeProvider>
                                                <LoaderProvider>
                                                    {children}
                                                </LoaderProvider>
                                            </EditTypeProvider>
                                        </SavedConfigurationsProvider>
                                    </AuthProvider>
                                </ModalProvider>
                            </LettersProvider>
                        </PriceCalculationProvider>
                        </TextSectionsListProvider>
                    </PriceProvider>
                </WorkingSizeProvider>
            </ConfigProvider>
        </LanguageProvider>
    )
}